import Api from "./Api";

export default {
  getCompanyStatistics(company_id) {
    return Api().get(`statistics/${company_id}`);
  },
  getCompanyOverviewStatistics(company_id) {
    return Api().get(`company-stats/${company_id}`);
  },
  getCompanySetupProgress(company_id) {
    return Api().get(`company-setup-progress/${company_id}`);
  },
};
